import React from 'react';
import { Alert, Box, Button } from '@mui/material';

interface StepNavProps {
  onBack?: () => void;
  onNext: () => void;
  nextLabel?: string;
  nextDisabled?: boolean;
  backDisabled?: boolean;
  missing: string[];
  showMissing?: boolean;
}

/** Back/Next row plus a list of why the step cannot continue. */
const StepNav: React.FC<StepNavProps> = ({
  onBack,
  onNext,
  nextLabel = 'Next',
  nextDisabled = false,
  backDisabled = false,
  missing,
  showMissing = false,
}) => (
  <>
    {showMissing && missing.length > 0 && (
      <Alert severity="error" sx={{ mt: 2 }} role="alert">
        Complete the following to continue:
        <Box component="ul" sx={{ mt: 0.5, mb: 0, pl: 2.5 }}>
          {missing.map((item) => (
            <Box component="li" key={item} sx={{ typography: 'body2' }}>{item}</Box>
          ))}
        </Box>
      </Alert>
    )}
    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
      {onBack ? (
        <Button variant="outlined" onClick={onBack} disabled={backDisabled}>Back</Button>
      ) : (
        <span />
      )}
      <Button variant="contained" onClick={onNext} disabled={nextDisabled}>{nextLabel}</Button>
    </Box>
  </>
);

export default StepNav;
